import { makeStyles, Box, Paper } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Activities from "./components/Activities";
import Subjects from "./components/Subjects";
import AdminSupportMain from "./components/AdminSupportMain";

const useStyles = makeStyles((theme) => ({
  componentStyles: {
    padding: "16px",
  },

  navBox: {
    marginRight: "24px",
  },
  navPaper: {
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "8px",
    height: "360px",
    width: "240px",
    padding: "12px 8px",
    textAlign: "center",
  },
  selectedNavItem: {
    padding: "8px",
    fontSize: "14px",
    cursor: "pointer",
    color: "#ffffff",
    background: "#085F93",
    borderRadius: "8px",
    fontWeight: 600,
  },
  navItem: {
    padding: "8px",
    fontSize: "14px",
    cursor: "pointer",
    color: "#085F93",
    fontWeight: 600,
  },
  svgIcon: {
    float: "left",
    margin: "6px 6px 0 0",
  },

  pageTitle: {
    float: "left",
    whiteSpace: "nowrap",
  },
  selectedChildNav: {
    textAlign: "left",
    padding: "4px 0 4px 24px",
    cursor: "pointer",
    color: "#ffffff",
    fontWeight: 600,
    background: "#085F93",
    borderRadius: "4px",
  },
  childNav: {
    textAlign: "left",
    padding: "4px 0 4px 24px",
    cursor: "pointer",
    color: "#085F93",
    fontWeight: 600,
  },
}));

const pagesData = [
  {
    page: "ADMIN/SUPPORT",
    route: "/admin-support",
    children: [
      { page: "Activities", isSelected: false },
      { page: "Subjects", isSelected: false },
    ],
  },
];

export default function AdminSupport() {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const [pages, setPages] = useState(JSON.parse(JSON.stringify(pagesData)));

  useEffect(() => {
    if (
      !(
        (localStorage.getItem("roles") &&
          JSON.parse(localStorage.getItem("roles")).includes("RM")) ||
        JSON.parse(localStorage.getItem("roles")).includes("ADMIN")
      )
    )
      history.push("/");
  }, []);

  const onTabSelect = (item) => {
    if (item.children.length > 0) {
      const changeData = JSON.parse(JSON.stringify(pages));
      changeData.forEach((pageItem) => {
        pageItem.children.forEach((childItem) => {
          childItem.isSelected = false;
        });
      });
      setPages(changeData);
    }
    history.push(item.route);
  };

  const onChildNavClick = (parent, item) => {
    const changeData = JSON.parse(JSON.stringify(pages));
    changeData.forEach((pageItem) => {
      if (pageItem.page === parent.page) {
        pageItem.children.forEach((childItem) => {
          if (childItem.page === item.page) childItem.isSelected = true;
          else childItem.isSelected = false;
        });
      }
    });
    setPages(changeData);
  };

  const getMainData = () => {
    if (pages[0].children.filter((val) => val.isSelected).length > 0) {
      if (
        pages[0].children.filter((val) => val.isSelected)[0].page ===
        "Activities"
      ) {
        return <Activities />;
      } else return <Subjects />;
    } else {
      return <AdminSupportMain />;
    }
  };

  return (
    <div className={classes.componentStyles}>
      <Box style={{ marginTop: "12px" }} display="flex" flexDirection="row">
        <Box className={classes.navBox}>
          <Paper elevation={0} className={classes.navPaper}>
            {pages.map((item, i) => (
              <>
                <div
                  className={`${
                    location.pathname === item.route
                      ? classes.selectedNavItem
                      : classes.navItem
                  } clearfix`}
                  onClick={() => onTabSelect(item)}
                >
                  <span className={classes.pageTitle}>{item.page}</span>
                </div>
                {item.children.length > 0 &&
                  location.pathname === item.route && (
                    <div style={{ marginTop: "12px" }}>
                      {item.children.map((val, i) => (
                        <div
                          className={
                            val.isSelected
                              ? classes.selectedChildNav
                              : classes.childNav
                          }
                          onClick={() => onChildNavClick(item, val)}
                        >
                          {val.page}
                        </div>
                      ))}
                    </div>
                  )}
              </>
            ))}
          </Paper>
        </Box>
        <Box style={{ width: "100%" }}>{getMainData()}</Box>
      </Box>
    </div>
  );
}
